<template>
  <v-dialog v-model="show" max-width="400" persistent>
    <v-card>
      <v-btn
        icon
        @click="close"
        style="
          position: absolute;
          top: 5px;
          right: -12px;
          width: 21px;
          height: 21px;
          z-index: 1;
        "
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-title>
        <h2 style="font-size: 21px">
          {{ 'Agendamento de Evento' }}
        </h2>
      </v-card-title>
      <v-divider class="mt-3"></v-divider>
      <v-card-text
        v-if="
          event &&
          event.schedulingPatterns &&
          event.schedulingPatterns.length > 0
        "
      >
        <div class="mb-2">
          <v-icon left small>mdi-tune</v-icon>
          <strong>Padrão:</strong> {{ event.name || '—' }}
        </div>
        <div class="mb-2">
          <v-icon left small>mdi-tune</v-icon>
          <strong>Marca:</strong>
          {{ event.schedulingPatterns?.[0]?.pattern?.manufacturer || '—' }}
        </div>
        <div class="mb-2">
          <v-icon left small>mdi-tune</v-icon>
          <strong>Modelo:</strong>
          {{ event.schedulingPatterns[0]?.pattern?.model || '—' }}
        </div>
        <div class="mb-2">
          <v-icon left small>mdi-tune</v-icon>
          <strong>Número de série:</strong>
          {{ event.schedulingPatterns?.[0]?.pattern?.serialNumber || '—' }}
        </div>
        <div class="mb-2">
          <v-icon left small>mdi-tune</v-icon>
          <strong>Patrimônio:</strong>
          {{ event.schedulingPatterns?.[0]?.pattern?.propertyCode || '—' }}
        </div>
        <div class="mb-2">
          <v-icon left small>mdi-calendar-start</v-icon>
          <strong>Início:</strong> {{ event.startDate | formatDate }}
        </div>
        <div class="mb-2">
          <v-icon left small>mdi-calendar-end</v-icon>
          <strong>Término:</strong> {{ event.endDate | formatDate }}
        </div>
        <div class="mb-2">
          <v-icon left small>mdi-clock-outline</v-icon>
          <strong>Horário:</strong> {{ event.startDate | formatTime }}
        </div>
        <div class="mb-2">
          <v-icon left small>mdi-domain</v-icon>
          <strong>Instituição:</strong> {{ event.fromInstitution?.name }}
        </div>
        <div class="mb-2" v-if="!event.supplierId">
          <v-icon left small>mdi-domain</v-icon>
          <strong>Instituição de destino:</strong>
          {{ event.toInstitution?.name }}
        </div>
        <div class="mb-2" v-if="event.supplierId">
          <v-icon left small>mdi-truck</v-icon>
          <strong>Fornecedor:</strong>
          {{ supplierName }}
        </div>
        <div class="mb-2">
          <v-icon left small>mdi-text</v-icon>
          <strong>Observação:</strong>
          {{ event.details || 'Sem detalhes fornecidos' }}
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn
          class="primary-button ma-1"
          color="error"
          @click="showDeleteConfirm = true"
          depressed
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn class="primary-button ma-1" text @click="editEvent" depressed>
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="showDeleteConfirm" max-width="300">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza que deseja excluir os item selecionado?') }}
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            depressed
            @click="showDeleteConfirm = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="error"
            text
            depressed
            @click="confirmDelete"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>
  </v-dialog>
</template>

<script>
import ApiService from '@/services/ApiService'
export default {
  name: 'EventDetailsDialog',
  data() {
    return {
      apiService: new ApiService(),
      showDeleteConfirm: false,
      loading: false,
      supplierName: '',
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    event: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {
    event: {
      handler(newEvent) {
        if (newEvent && newEvent.supplierId) {
          this.getSupplier(newEvent.supplierId)
        } else {
          this.supplierName = ''
        }
      },
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown)
  },

  methods: {
    handleKeyDown(e) {
      if (e.key === 'Escape' && this.show) {
        this.close()
      }
    },
    close() {
      this.show = false
    },
    editEvent() {
      this.$emit('edit-event', this.event)
      this.close()
    },
    confirmDelete() {
      this.$emit('event-deleted', this.event)
      this.showDeleteConfirm = false
      this.close()
    },
    async getSupplier(supplierId) {
      try {
        // Primeiro busca a lista de fornecedores
        const institution = JSON.parse(localStorage.getItem('institution'))
        const response = await this.apiService.get(`supplier/list/${institution.id}`)
        const suppliers = response.content || []
        
        // Busca o fornecedor específico na lista
        const supplier = suppliers.find(s => s.id == supplierId)
        this.supplierName = supplier?.name || 'Fornecedor não encontrado'
      } catch (error) {
        console.error('Erro ao buscar fornecedor:', error)
        this.supplierName = 'Erro ao carregar fornecedor'
      }
    },
  },
  filters: {
    formatDate(date) {
      if (!date) return ''
      return new Intl.DateTimeFormat('pt-BR', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }).format(new Date(date))
    },
    formatTime(date) {
      if (!date) return ''
      return new Intl.DateTimeFormat('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).format(new Date(date))
    },
  },
}
</script>
